jQuery(document).ready(function ($) {
  function gatherAccordions() {
    var r = $.Deferred();
    $(':not(.accordion) + .accordion, * > .accordion:first-of-type').each(function () {
      $(this).nextUntil(':not(.accordion)').addBack().wrapAll('<div class="accordions active" />');
    });
    return r;
  }

  // Per Rebecca: I turned this off for now because when nesting accordions, it will create another button inside the button on the nested accordions therefore creaing multiple toggles

  // function accordionTitles() {
  //   var r = $.Deferred();
  //   var accordionCount = 0;
  //   $('.accordions').each(function () {
  //     var thisAccordion = $(this);
  //     accordionCount++;
  //     var titleCount = 0;
  //     thisAccordion.find('.accordion .accordion-title').each(function () {
  //       titleCount++;
  //       var $this = $(this);
  //       var id = 'accordion-' + accordionCount + '-' + titleCount;
  //       var titleID = 'accordion-title-' + accordionCount + '-' + titleCount;
  //       $this.attr('id', titleID);
  //       if ($this.hasClass('open')) {
  //         $this.addClass('is-active');
  //         if ($this.is('div')) {
  //           $('h2', $this).wrapInner('<button onclick="return false;" aria-expanded="true" aria-controls="' + id + '">');
  //         } else {
  //           $this.wrapInner('<button onclick="return false;" aria-expanded="true" aria-controls="' + id + '">');
  //         }
  //       } else {
  //         if ($this.is('div')) {
  //           $('h2', $this).wrapInner('<button onclick="return false;" aria-expanded="false" aria-controls="' + id + '">');
  //         } else {
  //           $this.wrapInner('<button onclick="return false;" aria-expanded="false" aria-controls="' + id + '">');
  //         }
  //       }
  //     })
  //   });

  //   return r;
  // }

  function accordionTitles() {
    var r = $.Deferred();
    var titleCount = 0;
    $('.accordions .accordion-title').each(function () {
      titleCount++;
      var $this = $(this);
      var id = 'accordion-' + titleCount;
      if ($this.hasClass('open')) {
        $this.addClass('is-active');
        if ($this.is('div')) {
          $('h2', $this).wrapInner('<button onclick="return false;" aria-expanded="true" aria-controls="' + id + '">');
        } else {
          $this.wrapInner('<button onclick="return false;" aria-expanded="true" aria-controls="' + id + '">');
        }
      } else {
        if ($this.is('div')) {
          $('h2', $this).wrapInner('<button onclick="return false;" aria-expanded="false" aria-controls="' + id + '">');
        } else {
          $this.wrapInner('<button onclick="return false;" aria-expanded="false" aria-controls="' + id + '">');
        }
      }
    });
    return r;
  }

  // Per Rebecca: I turned this off for now because when nesting accordions, it will create another button inside the button on the nested accordions therefore creaing multiple toggles.

  // function accordionContent() {
  //   var r = $.Deferred();
  //   var accordionCount = 0;
  //   $('.accordions').each(function () {
  //     accordionCount++;
  //     var thisAccordion = $(this);
  //     var contentCount = 0;
  //     thisAccordion.find('.accordion .accordion-content').each(function () {
  //       contentCount++;
  //       var $this = $(this);
  //       var id = 'accordion-' + accordionCount + '-' + contentCount;
  //       if ($this.prev('.accordion-title').hasClass('is-active')) {
  //         $this.attr('id', id).attr('aria-hidden', 'false');
  //       } else {
  //         $this.attr('id', id).attr('aria-hidden', 'true');
  //       }
  //     });
  //   });
  //   return r;
  // }

  function accordionContent() {
    var r = $.Deferred();
    var contentCount = 0;
    $('.accordions .accordion-content').each(function () {
      contentCount++;
      var $this = $(this);
      var id = 'accordion-' + contentCount;
      if ($this.prev('.accordion-title').hasClass('is-active')) {
        $this.attr('id', id).attr('aria-hidden', 'false');
      } else {
        $this.attr('id', id).attr('aria-hidden', 'true');
      }
    });
    return r;
  }

  function accordionButtons() {
    $('.accordions .accordion-title button').on('click', function (e) {
      e.preventDefault();
      var id = $(this).attr('aria-controls');
      var state = $(this).attr('aria-expanded');
      var panel = $('.accordion-content#' + id);
      if ($(this).parent().hasClass('is-active')) {
        $(this).parent().removeClass('is-active').addClass('is-inactive');
        $(this).attr('aria-expanded', 'false');
        panel.attr('aria-hidden', 'true');
        panel.animate({
          height: 0
        }, 250);
      } else {
        $(this).parent().removeClass('is-inactive').addClass('is-active');
        $(this).attr('aria-expanded', 'true');
        panel.attr('aria-hidden', 'false');
        panel.animate({
          height: panel.data('scrollheight')
        }, 250, function () {
          panel.height('auto');
        });
      }
    });
  }
  gatherAccordions().done(accordionTitles().done(accordionContent().done(accordionButtons())));

  if (window.location.hash) {
    var hash = window.location.hash;
    var urlAccordion = $('.accordion-title' + hash);
    if (urlAccordion.length) {
      console.log('has hash');
      urlAccordion.addClass('is-active');
      urlAccordion.find('> button').attr('aria-expanded', 'true');
      urlAccordion.next('.accordion-content').attr('aria-hidden', 'false');
    }
  }
});